<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

// Three guide cards on top of the integrations grid (owner order 2026-09-14):
// where channels really live, how webhooks connect to Zapier/Make/n8n, and
// the Google Sheets export. Text only, no backend.
const { t } = useI18n();

const cards = [
  {
    key: 'CHANNELS',
    icon: 'i-lucide-message-square-share',
    tile: 'bg-[#25D366] text-white',
    to: { name: 'settings_inbox_list' },
  },
  {
    key: 'WEBHOOKS',
    icon: 'i-lucide-webhook',
    tile: 'bg-[#7C3AED] text-white',
    to: {
      name: 'settings_integrations_teletel_guide',
      params: { guide: 'webhooks' },
    },
  },
  {
    key: 'SHEETS',
    icon: 'i-lucide-table',
    tile: 'bg-[#0F9D58] text-white',
    to: {
      name: 'settings_integrations_teletel_guide',
      params: { guide: 'sheets' },
    },
  },
];
</script>

<template>
  <section class="flex flex-col gap-3">
    <div>
      <h2 class="text-heading-3 text-n-slate-12 mb-0">
        {{ t('INTEGRATION_SETTINGS.TELETEL_GUIDES.TITLE') }}
      </h2>
      <p class="text-body-main text-n-slate-11 mb-0">
        {{ t('INTEGRATION_SETTINGS.TELETEL_GUIDES.DESCRIPTION') }}
      </p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <div
        v-for="card in cards"
        :key="card.key"
        class="flex flex-col flex-1 p-4 m-px outline outline-n-container outline-1 bg-n-card rounded-xl"
      >
        <div
          class="flex items-center justify-center size-12 mb-2 rounded-md border border-n-weak shadow-sm"
          :class="card.tile"
        >
          <Icon :icon="card.icon" class="size-6" />
        </div>
        <div class="flex flex-col flex-1 gap-2">
          <span class="text-heading-3 text-n-slate-12">
            {{
              t(`INTEGRATION_SETTINGS.TELETEL_GUIDES.CARDS.${card.key}.TITLE`)
            }}
          </span>
          <p class="text-n-slate-11 text-body-main mb-0 flex-1">
            {{
              t(
                `INTEGRATION_SETTINGS.TELETEL_GUIDES.CARDS.${card.key}.DESCRIPTION`
              )
            }}
          </p>
          <router-link :to="card.to" class="w-fit">
            <Button
              :label="
                t(
                  `INTEGRATION_SETTINGS.TELETEL_GUIDES.CARDS.${card.key}.ACTION`
                )
              "
              icon="i-lucide-arrow-up-left"
              link
              xs
            />
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>
